import { dateSerializer } from 'domain/entity/common/utils';
import { ReportInstanceScope } from 'domain/entity/reportInstance';
import { JsonObject, JsonProperty } from 'typescript-json-serializer';
import { Periodicity } from 'use-case/automation/create/createAutomationCriteria';

@JsonObject()
export class ReportingVisibility {
    constructor(
        @JsonProperty({ required: true })
        public readonly scope: ReportInstanceScope,

        @JsonProperty({ required: true })
        public readonly users: Array<{ id: string; email: string }>
    ) {}
}

@JsonObject()
export class Automation {
    constructor(
        @JsonProperty({ required: true })
        public readonly id: string,

        @JsonProperty({ required: true })
        public readonly templateDashboardId: string,

        @JsonProperty({ required: true })
        public readonly templateDashboardName: string,

        @JsonProperty({ required: true })
        public readonly language: string,

        @JsonProperty({ required: true })
        public readonly languageName: string,

        @JsonProperty({ required: true })
        public readonly locationIds: string[],

        @JsonProperty({ required: true })
        public readonly locationNames: string[],

        @JsonProperty({ required: true })
        public readonly locationTags: string,

        @JsonProperty({ required: true, beforeDeserialize: dateSerializer })
        public readonly start: Date,

        @JsonProperty({ required: true, beforeDeserialize: dateSerializer })
        public readonly end: Date,

        @JsonProperty({ required: true })
        public readonly periodicity: Periodicity,

        @JsonProperty({ required: true })
        public readonly delayDays: number,

        @JsonProperty({ required: true, type: ReportingVisibility })
        public readonly reportingVisibility: ReportingVisibility,

        @JsonProperty({ required: true })
        public readonly active: boolean
    ) {}
}
